import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "ftp-access-is-closed" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "m-top-20 m-bottom-5" }, "FTP access is closed.", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "c-primary-grey" }, "To start using FTP, please use our subscription.", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ModalChangeSubscription = _resolveComponent("ModalChangeSubscription")!
  const _component_IconFTPAccessIsClosed = _resolveComponent("IconFTPAccessIsClosed")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.showModalChangeSubscription)
      ? (_openBlock(), _createBlock(_component_ModalChangeSubscription, {
          key: 0,
          title: "Start using IMDatacenter",
          plans: _ctx.accessibilityPlan,
          onClose: _ctx.closeModalChangeSubscription
        }, null, 8, ["plans", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_IconFTPAccessIsClosed),
      _hoisted_2,
      _hoisted_3,
      _createElementVNode("button", {
        class: "btn border medium m-top-30",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showModalChangeSubscription = true))
      }, "Start prepayment")
    ])
  ], 64))
}